import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getBaseSourcesLoading, getManagePermissionsPage } from '../selectors';
import { hidePage, hidePageCalled, managePermissionsFinished, selectedTabIndexChanged } from '../actions';
import ManagePermissionsPage from '../components/ManagePermissionsPage';

const mapStateToProps = state => ({
    ...getManagePermissionsPage(state),
    sourcesLoading: getBaseSourcesLoading(state),
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            onHidePage: hidePageCalled,
            onDirectHidePage: hidePage,
            onManagePermissionsFinished: managePermissionsFinished,
            onSelectedTabIndexChanged: selectedTabIndexChanged,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ManagePermissionsPage);
